import { Cookie, ResolverTag } from '@ps/web-core-enums';
import { canUseDOM } from '@ps/web-core-utils';
import { useSelector } from 'react-redux';
import Cookies from 'universal-cookie';

import { useVary } from '@swf/components/ResponseHeaders/ResponseHeaders';
import { Header } from '@swf/core/enums';
import { select } from '@swf/core/store';
import { useResolverTagService } from '@swf/poker';

const cookies = new Cookies();

const useGameUrlPayload = () => {
  useVary({ by: [Header.TimeZone] });

  const resolver = useResolverTagService(ResolverTag.WebPoker);
  const brand = useSelector(select.cms.getBrandId);
  const site = useSelector(select.cms.getSiteId);
  const timezone = useSelector(select.timeZone.getGmtOffset);
  const country = useSelector(select.account.getCountry);
  const xiid = cookies.get(Cookie.INSTALL_ID);
  const origin = canUseDOM ? window.location.origin : '';
  const newtab = true;
  return { resolver, brand, site, origin, country, xiid, timezone, newtab };
};

export default useGameUrlPayload;
